import type {ReactElement} from 'react';
import React from 'react';
import type {DropdownItemStorage} from '@Components/contextual-menu/components/contextual-menu-dropdown-option';
import {DROPDOWN_POSITION} from '@Components/dropdown-v2/dropdown.types';
import {PosterEditingBaseDropdownOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/poster-editing-base-dropdown-option';
import {AnimationSpeed} from '@/poster-whiteboard/classes/item-animation.class';

interface BaseTransitionSpeedOptionProps {
  onToggleSpeed(id: AnimationSpeed): void;
  selectedId: AnimationSpeed;
}

export function BaseTransitionSpeedOption({...props}: BaseTransitionSpeedOptionProps): ReactElement<any> {
  const getSpeedDropdownItems = (): DropdownItemStorage[] => {
    return [
      {id: AnimationSpeed.LOWER, text: window.i18next.t('pmwjs_slower')},
      {id: AnimationSpeed.LOW, text: window.i18next.t('pmwjs_slow')},
      {id: AnimationSpeed.MEDIUM, text: window.i18next.t('pmwjs_medium')},
      {id: AnimationSpeed.HIGH, text: window.i18next.t('pmwjs_fast')},
      {id: AnimationSpeed.HIGHER, text: window.i18next.t('pmwjs_faster')},
    ];
  };
  return (
    <PosterEditingBaseDropdownOption
      position={DROPDOWN_POSITION.FIXED}
      isForSubOption
      dropdownItems={getSpeedDropdownItems()}
      id="page-animation-speed-option"
      label={window.i18next.t('pmwjs_speed')}
      onClick={(id: AnimationSpeed): void => {
        props.onToggleSpeed(id);
      }}
      selectedItemId={props.selectedId}
      leftOffset={12}
    />
  );
}
